import * as React from 'react'
import Map from 'google-map-react'
import PinIcon from '../Icons/Map'
import { getLocaleFromPath } from '../../utils/i18n'
import locations from '../../data/googleMapLocations'

import s from './styles.module.css'

const Pin = ({ text }) => (
  <div className={s.pin}>
    <PinIcon className={s.icon} />
    {text}
  </div>
)

const AugustaMap = ({ zoom }) => (
  <Map
    bootstrapURLKeys={{
      key: 'AIzaSyDH6NArHt8HDwoL9Xb9Ky4sy1gLmmGfpVc',
      libraries: 'places',
      language: getLocaleFromPath(),
      region: getLocaleFromPath()
    }}
    options={maps => ({
      zoomControl: true,
      mapTypeControl: true,
      panControl: false,
      scrollwheel: false,
      mapTypeControlOptions: {
        position: maps.ControlPosition.LEFT_TOP
      }
    })}
    defaultCenter={{
      lat: 42.7498022,
      lng: 16.8764021
    }}
    defaultZoom={zoom || 13}
  >
    {locations.map(({ text, lat, lng }, idx) => (
      <Pin text={text} lat={lat} lng={lng} key={idx} />
    ))}
  </Map>
)

export default AugustaMap



// WEBPACK FOOTER //
// ./src/components/AugustaMap/index.js